import {primitive} from "serializr";
import {makeAutoObservable} from "mobx";

import {createModelSchemaWrapper} from "framework/serializr-integration";
import {DataRegistryCategoryLayout} from "areas/management/data-registry/dataRegistryCategoryLayout";


export class DataRegistryWindowSettings {
	categorizeBy: DataRegistryCategoryLayout = DataRegistryCategoryLayout.Asset;

	constructor() {
		makeAutoObservable(this)
	}
}

createModelSchemaWrapper(DataRegistryWindowSettings, {
	categorizeBy: primitive()
})
